import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-24f7c2de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header_left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "javascript:void(0);" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]

import { HeadNavItem } from "@/types/header";
import { ref, reactive, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'MenusMain',
  emits: ["close"],
  setup(__props, { emit }) {

const store = useStore();
const router = useRouter();
const route = useRoute();
const isMobile = computed(() => !!store.state.isMobile);
// 判断是否为新手引导状态
const driverState = computed(() => !!store.getters.getDriverState);
const menuPosition = computed(() => {
  route.meta?.mainMenuPosition;
});
const showMobileDownLoadBox = () => {
  store.dispatch("changeMobileDownloadTips", true);
};
const headerMenus = reactive<HeadNavItem[]>([
  {
    url: "/",
    lang: "header.product",
    name: "home",
  },
  {
    url: "/privilege",
    lang: "header.privilege",
    name: "privilege",
  },
  {
    url: "/help",
    lang: "header.help",
    name: "help",
  },
]);
const activeMenuName = computed(() => {
  if (route.meta?.mainMenuPosition === "helpBooks") {
    return "help";
  }
  return route.meta?.mainMenuPosition || "";
});

const changeRouter = (menu: HeadNavItem): void | boolean => {
  if (driverState.value) {
    return false;
  } else {
    store.dispatch("changeMobileDownloadTips", false);
    ElMessage.closeAll();
    emit("close");
    router.push(menu.url);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "logo",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeRouter({ url: '/', lang: 'header.product', name: 'home' })))
        }, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerMenus, (menu, i) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass([
          { active: _unref(activeMenuName) === menu.name },
          { mobileSize: _unref(isMobile) },
          menu.name,
        ]),
          key: 'menu' + i,
          onClick: ($event: any) => (changeRouter(menu))
        }, _toDisplayString(_ctx.$t(menu.lang)), 11, _hoisted_4))
      }), 128)),
      (_unref(isMobile))
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            onClick: showMobileDownLoadBox
          }, _toDisplayString(_ctx.$t("header.DECDow")), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})